import { motion } from "framer-motion";
import { ArrowUpRight, CalendarClock } from "lucide-react";
import { MaskLines, Magnetic, scrollToId } from "../lib/motion";

const scrollTo = scrollToId;

export default function Hero({ ready }) {
  return (
    <section
      id="hero"
      className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden px-6 text-center"
      data-testid="hero-section"
    >
      <div className="orb orb-blue left-[10%] top-[20%] h-[420px] w-[420px]" />
      <div className="orb orb-purple right-[8%] bottom-[15%] h-[380px] w-[380px]" />

      <motion.div
        initial={{ opacity: 0, y: 14 }}
        animate={ready ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.9, delay: 0.1 }}
        className="mb-8 flex items-center gap-2.5 rounded-full glass px-4 py-2"
        data-testid="hero-badge"
      >
        <span className="relative flex h-2 w-2">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-nexis-blue opacity-75" />
          <span className="relative inline-flex h-2 w-2 rounded-full bg-nexis-blue" />
        </span>
        <span className="font-mono text-xs tracking-[0.2em] text-white/70">
          BOUTIQUE STRATEGIC CONSULTING
        </span>
      </motion.div>

      <h1 className="font-display text-5xl font-light leading-[1.02] tracking-tighter sm:text-6xl lg:text-8xl">
        <MaskLines
          lines={["Building Tomorrow's"]}
          className="block text-white"
          start={0.15}
        />
        <MaskLines
          lines={["Enterprise"]}
          className="block text-gradient font-semibold"
          start={0.32}
        />
      </h1>

      <motion.p
        initial={{ opacity: 0, y: 16 }}
        animate={ready ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 1, delay: 0.9 }}
        className="mt-8 max-w-xl font-display text-lg font-light text-white/60"
        data-testid="hero-subline"
      >
        <span className="text-white/90">Infrastructure. Transformation. Intelligence.</span>{" "}
        Become one.
      </motion.p>

      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={ready ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 1, delay: 1.05 }}
        className="mt-11 flex flex-col items-center gap-4 sm:flex-row"
      >
        <Magnetic strength={0.5}>
          <button
            onClick={() => scrollTo("services")}
            className="group flex items-center gap-2 rounded-full bg-nexis-blue px-7 py-3.5 font-medium text-black shadow-[0_0_40px_rgba(0,200,255,0.35)] transition-shadow hover:shadow-[0_0_60px_rgba(0,200,255,0.55)]"
            data-testid="hero-cta-explore"
          >
            Explore Nexis
            <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </button>
        </Magnetic>
        <Magnetic strength={0.5}>
          <button
            onClick={() => scrollTo("contact")}
            className="flex items-center gap-2 rounded-full glass glass-hover px-7 py-3.5 font-medium text-white"
            data-testid="hero-cta-consult"
          >
            <CalendarClock className="h-4 w-4 text-nexis-blue" />
            Schedule Consultation
          </button>
        </Magnetic>
      </motion.div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={ready ? { opacity: 1 } : {}}
        transition={{ duration: 1, delay: 1.4 }}
        className="absolute bottom-8 left-1/2 flex -translate-x-1/2 flex-col items-center gap-2"
      >
        <span className="font-mono text-[10px] tracking-[0.3em] text-white/40">SCROLL TO ENTER</span>
        <motion.div
          animate={{ y: [0, 8, 0] }}
          transition={{ duration: 1.8, repeat: Infinity, ease: "easeInOut" }}
          className="h-9 w-5 rounded-full border border-white/20 p-1"
        >
          <div className="mx-auto h-2 w-px bg-nexis-blue" />
        </motion.div>
      </motion.div>
    </section>
  );
}
